import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TabView, TabPanel } from 'primereact/tabview'
import { TAB_MENUS } from 'Utils/Constants/RouteStrings'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import DialogModal from 'Components/UIComponents/DialogModal'
import LayoutContainer from 'Components/LayoutComponent'
import UserInformation from './Components/UserInformation'
import UserSetting from './Components/UserSetting'
import UserCommunities from './Components/UserCommunities'

const UserSettings = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const urlParams = new URLSearchParams(history.location.search)
  const location = useLocation()
  const allUserData = location?.state[0] ?? []
  const tabMapping = [TAB_MENUS.userInformation, TAB_MENUS.userSettings, TAB_MENUS.userCommunity]

  const initialActiveTab = urlParams.get('tab') || TAB_MENUS.userInformation
  const [activeTab, setActiveTab] = useState(initialActiveTab)
  const [showDialog, setShowDialog] = useState({ showModal: false, modalCancel: false, modalType: '', message: '', onDismiss: () => {}, onRetry: () => {}, onHide: () => {}, onSuccess: () => {}, onConfirmation: () => {} })

  // Then pass it to children

  useEffect(() => {
    const params = new URLSearchParams()

    params.set('tab', activeTab)
    history.replace({
      pathname: history.location.pathname,
      search: params.toString(),
      state: history.location.state
    })
  }, [activeTab, history])

  const handleTabChange = (index) => {
    setActiveTab(tabMapping[index] || tabMapping[0])
  }

  const handleDismiss = () => {
    setShowDialog({ ...showDialog, showModal: false })
  }

  return (
    <LayoutContainer title={t('USER_SETTINGS')} breadCrumbsTitle={'userSettings'}>
      <div className="card">
        <div className="tab-container">
          <TabView activeIndex={tabMapping.indexOf(activeTab)} onTabChange={(e) => handleTabChange(e.index)}>
            <TabPanel header={t('USER_INFORMATION')} className="app-settings-tab-panel">
              <UserInformation allUserData={allUserData} />
            </TabPanel>
            <TabPanel header={t('SETTINGS')} className="app-settings-tab-panel">
              <UserSetting allUserData={allUserData} />
            </TabPanel>
            <TabPanel header={t('USER_COMMUNITIES')} className="app-settings-tab-panel">
              <UserCommunities allUserData={allUserData} />
            </TabPanel>
          </TabView>
        </div>
      </div>

      <DialogModal {...showDialog} onDismiss={handleDismiss} />
    </LayoutContainer>
  )
}

export default UserSettings
